import axios from 'axios';
import { getBaseUrlAnalista, getBaseUrlSolicitante, ensureProtocol } from '../config/backend';

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

function baseUrlAnalista() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function baseUrlSolicitante() {
  return getBaseUrlSolicitante() || ensureProtocol(localStorage.getItem('ipBackend') || '');
}

export async function fetchEmpresas() {
  const url = baseUrlAnalista() ? baseUrlAnalista() + '/empresas' : '/empresas';
  const { data } = await axios.get(url, { headers: getAuthHeaders() });
  return Array.isArray(data) ? data : [];
}

export async function fetchEmpresaById(id) {
  const url = baseUrlAnalista() ? baseUrlAnalista() + '/empresas/' + id : '/empresas/' + id;
  const { data } = await axios.get(url, { headers: getAuthHeaders() });
  return data;
}

export async function createEmpresa(payload) {
  const url = baseUrlAnalista() ? baseUrlAnalista() + '/empresas' : '/empresas';
  const { data } = await axios.post(url, payload, { headers: getAuthHeaders() });
  return data;
}

export async function updateEmpresa(id, payload) {
  const url = baseUrlAnalista() ? baseUrlAnalista() + '/empresas/' + id : '/empresas/' + id;
  const { data } = await axios.put(url, payload, { headers: getAuthHeaders() });
  return data;
}

export async function updateStatusConclusaoPrincipal(id, statusConclusaoPrincipalId) {
  const url = baseUrlAnalista() ? baseUrlAnalista() + '/empresas/' + id + '/status-conclusao-principal' : '/empresas/' + id + '/status-conclusao-principal';
  const { data } = await axios.put(url, { status_conclusao_principal_id: statusConclusaoPrincipalId }, { headers: getAuthHeaders() });
  return data;
}

export async function fetchHorarioEmpresa(id) {
  const url = baseUrlAnalista() ? `${baseUrlAnalista()}/empresas/${id}/horario-funcionamento` : `/empresas/${id}/horario-funcionamento`;
  const { data } = await axios.get(url, { headers: getAuthHeaders() });
  return data;
}

export async function salvarHorarioEmpresa(id, payload) {
  const url = baseUrlAnalista() ? `${baseUrlAnalista()}/empresas/${id}/horario-funcionamento` : `/empresas/${id}/horario-funcionamento`;
  const { data } = await axios.put(url, payload, { headers: getAuthHeaders() });
  return data;
}

export async function fetchFeriadosEmpresa(id) {
  const url = baseUrlAnalista() ? `${baseUrlAnalista()}/empresas/${id}/feriados` : `/empresas/${id}/feriados`;
  const { data } = await axios.get(url, { headers: getAuthHeaders() });
  return Array.isArray(data) ? data : [];
}

export async function adicionarFeriadoEmpresa(id, payload) {
  const url = baseUrlAnalista() ? `${baseUrlAnalista()}/empresas/${id}/feriados` : `/empresas/${id}/feriados`;
  const { data } = await axios.post(url, payload, { headers: getAuthHeaders() });
  return data;
}

export async function removerFeriadoEmpresa(id, feriadoId) {
  const url = baseUrlAnalista() ? `${baseUrlAnalista()}/empresas/${id}/feriados/${feriadoId}` : `/empresas/${id}/feriados/${feriadoId}`;
  const { data } = await axios.delete(url, { headers: getAuthHeaders() });
  return data;
}

export async function solicitarRecalculoSla(empresaId) {
  const url = baseUrlAnalista() ? `${baseUrlAnalista()}/satis/recalcular-sla` : '/satis/recalcular-sla';
  const { data } = await axios.post(
    url,
    { empresa_id: empresaId },
    { headers: getAuthHeaders() }
  );
  return data;
}

export async function fetchMinhasEmpresas() {
  const url = baseUrlAnalista() ? baseUrlAnalista() + '/empresas/minhas' : '/empresas/minhas';
  try {
    const { data } = await axios.get(url, { headers: getAuthHeaders(), timeout: 10000 });
    const arr = Array.isArray(data) ? data : (Array.isArray(data?.empresas) ? data.empresas : []);
    return arr.map((e) => ({ id: e.id ?? e.empresa_id, nome: e.nome ?? e.empresa_nome ?? '' }));
  } catch (err) {
    if (err?.response?.status === 404 || err?.response?.status === 501) return [];
    throw err;
  }
}

export async function fetchMinhasEmpresasSolicitante() {
  const url = baseUrlSolicitante() ? baseUrlSolicitante() + '/empresas/minhas' : '/empresas/minhas';
  try {
    const { data } = await axios.get(url, { headers: getAuthHeaders(), timeout: 10000 });
    const arr = Array.isArray(data) ? data : (Array.isArray(data?.empresas) ? data.empresas : []);
    return arr.map((e) => ({ id: e.id ?? e.empresa_id, nome: e.nome ?? e.empresa_nome ?? '' }));
  } catch (err) {
    if (err?.response?.status === 404 || err?.response?.status === 501) return [];
    throw err;
  }
}

export async function setContextoEmpresaAnalista(empresaId) {
  const url = baseUrlAnalista() ? baseUrlAnalista() + '/token/contexto' : '/token/contexto';
  const { data } = await axios.post(url, { empresa_id: empresaId }, { headers: getAuthHeaders() });
  return data;
}

export async function setContextoEmpresaSolicitante(empresaId) {
  const url = baseUrlSolicitante() ? baseUrlSolicitante() + '/api/token/contexto' : '/api/token/contexto';
  const { data } = await axios.post(url, { empresa_id: empresaId }, { headers: getAuthHeaders(), timeout: 15000 });
  return data;
}
